<script setup>
import { i18n } from '../../../localization'
import {
    initializeInvestmentProcessNavigation,
    useInvestmentProcessNavigation,
} from '../../../utilities/account/useInvestmentProcessNavigation'
import DefaultInvestmentProcessInvestmentAmount from '../default/DefaultInvestmentProcessInvestmentAmount.vue'
import AltFgInvestmentProcessLegal from './AltFgInvestmentProcessLegal.vue'
import AltFgInvestmentProcessSummary from './AltFgInvestmentProcessSummary.vue'
import DefaultInvestmentProcessPayment from '../default/DefaultInvestmentProcessPayment.vue'
import { isLegalProfile, isNaturalProfile } from '../../../utilities/investment-process/useUserProfileType'
import InvestmentProcessWrapper from '../InvestmentProcessWrapper.vue'
import InvestmentProcessHeadline from '../InvestmentProcessHeadline.vue'
import InvestmentProcessSteps from '../InvestmentProcessSteps.vue'
import InvestmentProcessStepsMobile from '../InvestmentProcessStepsMobile.vue'
import NaturalProfileSidebarCard from '../sidebar/NaturalProfileSidebarCard.vue'
import LegalProfileSidebarCard from '../sidebar/LegalProfileSidebarCard.vue'
import CampaignSidebarCard from '../sidebar/CampaignSidebarCard.vue'

const steps = [
    {
        name: 'investmentAmount',
        label: i18n.global.t('investment_process.investment_amount'),
        component: DefaultInvestmentProcessInvestmentAmount,
    },
    {
        name: 'legal',
        label: i18n.global.t('investment_process.law_requirements'),
        component: AltFgInvestmentProcessLegal,
    },
    { name: 'summary', label: i18n.global.t('investment_process.summary'), component: AltFgInvestmentProcessSummary },
    { name: 'payment', label: i18n.global.t('investment_process.payment'), component: DefaultInvestmentProcessPayment },
]

initializeInvestmentProcessNavigation(steps)
</script>

<template>
    <InvestmentProcessWrapper>
        <template #header>
            <InvestmentProcessHeadline />
            <InvestmentProcessSteps />
            <InvestmentProcessStepsMobile />
        </template>
        <template #main>
            <component :is="useInvestmentProcessNavigation().currentStep.component"></component>
        </template>
        <template #sidebar>
            <div class="space-y-6">
                <NaturalProfileSidebarCard v-if="isNaturalProfile()"></NaturalProfileSidebarCard>
                <LegalProfileSidebarCard v-if="isLegalProfile()"></LegalProfileSidebarCard>
                <CampaignSidebarCard></CampaignSidebarCard>
            </div>
        </template>
    </InvestmentProcessWrapper>
</template>

<style scoped></style>
